
import { useMemo } from 'react';

type SizeOption = 'small' | 'medium' | 'large' | 'extra-large' | 'full';

interface SizeConfig {
  width: string | number;
  height: string | number;
}

export function useMapSizes(size: SizeOption = 'medium'): SizeConfig {
  const mapSizes = useMemo(() => ({
    small: {
      width: 200,
      height: 210  // Increased from 150 by 40%
    },
    medium: {
      width: '100%',
      height: 280  // Increased from 200 by 40%
    },
    large: {
      width: '100%',
      height: 350  // Increased from 250 by 40%
    },
    'extra-large': {
      width: '100%',
      height: 560  // Increased from 400 by 40%
    },
    full: {
      width: '100%',
      height: '100%'
    }
  }), []);

  return mapSizes[size];
}
